import React, { useState } from 'react';
import '../styles/TalentRequestModal.css';

const TalentRequestModal = ({ talent, onClose, onPurchaseCredits }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="talent-request-modal" onClick={e => e.stopPropagation()}>
        <button className="close-btn" onClick={onClose}>×</button>
        
        <div className="talent-info">
          <div className="talent-image-container">
            <img src={talent.image} alt={talent.name} className="talent-image" />
          </div>
          <div className="talent-details">
            <h2>{talent.name.toUpperCase()}</h2>
            <p className="talent-bio">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
            </p>
            <button className="preview-btn">Preview</button>
          </div>
        </div>

        {/* Full width divider */}
        <div className="modal-divider"></div>

        {/* Container for bottom content */}
        <div className="modal-bottom-content">
          <div className="request-form">
            <h3>Create a new request</h3>
            <div className="form-group">
              <label>Title:</label>
              <input 
                type="text" 
                placeholder="Name your message ( for identifying later )"
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Script / Message:</label>
              <textarea 
                placeholder="Script / Message you would like Heidi to read. Limit 150 words."
                className="form-input"
                rows={4}
              />
            </div>
          </div>

          <div className="credit-calculator">
            <h3>My Credit Calculator</h3>
            <div className="credit-info">
              <div className="credit-row">
                <span>Available Credits:</span>
                <span>0 credits</span>
              </div>
              <div className="credit-row">
                <span>Talent Request Cost:</span>
                <span>1 credits</span>
              </div>
              <div className="credit-row remaining">
                <span>Remaining Credits:</span>
                <span>0 credits</span>
              </div>
            </div>
            <button 
              className="purchase-credits-btn" 
              onClick={onPurchaseCredits}
            >
              Purchase more credits
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TalentRequestModal; 